import { h } from 'preact';
import { useState, useEffect, StateUpdater } from 'preact/hooks';
import register from '@wcd/preact-custom-element';
import { Avatar } from '../../../types/web-components';
import { isLoggedIn } from './cookies';

const sharedState: StateUpdater<string>[] = [];
let getAvatar;

export const component : Avatar = ({ width = 64, height = 64}) => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    sharedState.push(setUrl);
  }, []);

  useEffect(() => {
    if (!isLoggedIn) return;

    if (getAvatar) return;

    getAvatar = async () => {
      const response = await fetch(`/teaching-resource/api/avatar`, {});
      if (response.ok) { 
        const { url } = await response.json();
        for (const setState of sharedState) setState(url);
      }
    }

    getAvatar();
  }, []);

  
  return (
    <img 
      loading="lazy" 
      className="masthead__avatar-img" 
      src={url}
      width={width}
      height={height}      
      alt="user avatar"
    />
  );
}

register(component, 'tes-avatar', ['width', 'height'], { shadow: false });